import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

interface ProjectBreadcrumbProps {
  projectTitle?: string;
  projectId?: string;
  className?: string;
}

const ProjectBreadcrumb = ({ 
  projectTitle = 'Project Details', 
  projectId,
  className = '' 
}: ProjectBreadcrumbProps) => {
  const location = useLocation();
  const isProjectDetails = location.pathname.includes('/project-details');

  if (!isProjectDetails) return null;

  return (
    <nav className={`flex items-center space-x-2 text-sm text-text-secondary mb-6 ${className}`} aria-label="Breadcrumb">
      <Link 
        to="/home-landing"
        className="hover:text-accent transition-smooth"
      >
        Home
      </Link>
      
      <Icon name="ChevronRight" size={16} className="text-border" />
      
      <Link 
        to="/projects-showcase"
        className="hover:text-accent transition-smooth"
      >
        Projects
      </Link>
      
      <Icon name="ChevronRight" size={16} className="text-border" />
      
      <span className="text-text-primary font-medium truncate max-w-xs">
        {projectTitle}
      </span>
    </nav>
  );
};

export default ProjectBreadcrumb;